import { useState } from 'react'

import { safePhotoUrl } from '../../lib/publicProfile'

/**
 * A learner's profile photo (V5-w) where one exists, otherwise `children` —
 * the shop-avatar disc every screen already draws. The server sends
 * `photoUrl: null` for everyone while `social.photosEnabled` is off, so
 * until then every avatar is exactly what it was. A photo that fails to
 * load falls back to the disc too.
 */
export default function UserPhoto({ photoUrl, size, ring = false, children }) {
  const url = safePhotoUrl(photoUrl)
  const [failed, setFailed] = useState(null)
  if (!url || failed === url) return children
  return (
    <img
      src={url}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(url)}
      className={`shrink-0 rounded-full border-2 border-line bg-surface-2 object-cover ${ring ? 'ring-2 ring-surface' : ''}`}
      style={{ width: size, height: size }}
      data-photo="true"
    />
  )
}
